import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useFunctionsButtons } from '../../../../hooks/use-function-button.hook';
import useBgPages from '../../../../hooks/use-bg-pages.hook';
import Tooltip from '../../../../components/forms/tooltip.component';
import React from 'react';
import RedirectButton from './redirect-button.component';
import CallButton from './call-button.component';
import LocationButton from './location-button.component';
import CalendarButton from './calendar-button.component';
import AnswerButton from './answer-button.component';

declare global {
  interface Window {
    bootstrap?: any;
  }
}

function BuilderRCSSingleConversational() {
  useBgPages();
  const location = useLocation();
  const { t } = useTranslation();
  const { payload } = location.state || {};
  const actionComponents: Record<string, React.ComponentType<any>> = {
    redirect: RedirectButton,
    call: CallButton,
    location: LocationButton,
    calendar: CalendarButton,
    answer: AnswerButton
  };

  const { actions, handleGeneralActionClick, watch } = useFunctionsButtons();

  const suggestions = watch('suggestions') || [];

  return (
    <>
      {(() => {
        const suggestionActionCounts = (watch('suggestions') || []).reduce(
          (acc: any, action: any) => {
            if (acc[action.type] !== undefined) {
              acc[action.type]++;
            }
            return acc;
          },
          {
            redirect: 0,
            call: 0,
            location: 0,
            calendar: 0,
            answer: 0
          }
        );
        if (Array.isArray(watch('elements')) && watch('elements').length > 0) {
          return (
            <>
              <div className="separator separator-dashed separator-content text-dark my-10">
                <img
                  alt="Logo"
                  src="/assets/media/logos/logo-c.svg"
                  className="w-30px logo-minimize"
                />
              </div>
              <div className="fv-row mb-1">
                <div className="d-flex flex-stack cursor-pointer mb-3">
                  <div className="d-flex align-items-center me-2">
                    <span className="symbol me-6 symbol-label"></span>
                    <div className="d-flex flex-column mg-ch">
                      <span className="fw-bolder fs-3">
                        Botones Generales
                        <span className="fs-6 ms-1">({t('general.optional')})</span>
                      </span>
                      <span className="fs-6">
                        Elige máximo <strong className="text-danger">11</strong> botones generales.
                      </span>
                    </div>
                  </div>
                  <span className="form-check form-check-custom form-check-solid"></span>
                </div>
              </div>
              <div className="mb-8 bg-default p-2 rounded-12 w-100 text-nowrap">
                <div className="badge badge-lg badge-light-primary rounded-12">
                  {actions.map(({ key, icon, title, label }) => (
                    <div key={key} className="ms-4">
                      <Tooltip
                        title={title}
                        className="width-fit-content d-inline-block cursor-pointer"
                      >
                        <button
                          type="button"
                          onClick={(e) => {
                            const tooltipEl = e.currentTarget.closest('[data-bs-toggle="tooltip"]');
                            const tooltip = window.bootstrap?.Tooltip?.getInstance?.(tooltipEl);
                            tooltip?.hide?.();
                            handleGeneralActionClick(key);
                          }}
                          className="btn btn-sm rounded-12 align-items-center hover-scale px-0 py-3"
                        >
                          <div className="d-flex align-items-center cursor-pointer">
                            {icon}
                            <div className="fw-bolder ms-1">
                              <span className="d-none d-md-inline-block fs-7 text-primary">
                                {label}{' '}
                                {suggestionActionCounts[key] > 0 && (
                                  <span className="symbol-badge badge badge-circle bg-info text-white fw-bolder ms-1">
                                    {suggestionActionCounts[key]}
                                  </span>
                                )}
                              </span>
                            </div>
                          </div>
                        </button>
                      </Tooltip>
                    </div>
                  ))}
                </div>
              </div>
              <div className="mb-15">
                {suggestions?.map((action: any, actionIndex: number) => {
                  const ActionComponent = actionComponents[action.type];
                  if (!ActionComponent) return null;

                  const commonProps = {
                    actionIndexSugestionsGeneral: actionIndex,
                    type: 'suggestionsGeneral'
                  };
                  const isLast = actionIndex === suggestions.length - 1;
                  const shouldAddSeparator = suggestions.length > 1 && !isLast;

                  return (
                    <React.Fragment key={actionIndex}>
                      <ActionComponent
                        {...commonProps}
                        {...(action.type === 'calendar'
                          ? { payloadSuggestionGeneral: payload }
                          : {})}
                      />
                      {shouldAddSeparator && (
                        <div className="separator separator-dashed text-dark my-5 border-2"></div>
                      )}
                    </React.Fragment>
                  );
                })}
              </div>
            </>
          );
        }
        return null;
      })()}
    </>
  );
}

export default BuilderRCSSingleConversational;
